import { useTranslation } from 'react-i18next'
import React from 'react'
import {
  Body,
  Check,
  Container,
  Content,
  Footer,
  Header,
  TitleWrapper
} from './styles'
import { formatDuration } from 'utils/duration'
import { Flixx, Card } from 'ui'
import { useSession } from 'hooks'

const ContentCard = ({
  to,
  cover,
  isSelected,
  title,
  duration,
  body,
  isPurchased,
  price
}) => {

  const { t } = useTranslation()
  const { isLoggedIn } = useSession()

  return (
    <Container>
      <Card
        to={to}
        isSelected={isSelected}
        padding={{ all: 16 }}
      >
        <Content>
          <Header>
            <img src={cover} alt={title} />

            <TitleWrapper>
              <div>
                <h3>{title}</h3>
                <p>{formatDuration(duration)} {t('min')}</p>
              </div>
            </TitleWrapper>
          </Header>

          <Body>{body}</Body>

          { isLoggedIn && (
            <Footer>
              {isPurchased ? (
                <div>
                  <Check /> {t('bought')}
                </div>
              ) : (
                <div>
                  {t('watchFor')}:
                  <Flixx price={price} />
                </div>
              )}
            </Footer>
          )}
        </Content>
      </Card>
    </Container>
  )
}

export default ContentCard
